import profile from "../assets/images/profile.png";
import thumbnail from "../assets/images/thumbnail.png";
import cards from "../assets/images/cards.png";
import cards2 from "../assets/images/cards2.png";
import path from "../assets/images/path.png";
import logo from "../assets/images/logo.png";
import logo6 from "../assets/images/logo6.png";
import logoSmall from "../assets/images/logo-small.png";
import logoNew from "../assets/images/logo-new.png";
import empty from "../assets/images/empty.png";
import logoColor from "../assets/images/logo-color.png";
import toss from "../assets/images/toss.jpg";
import avatar from "../assets/images/avatar.png";
import collegeImg from "../assets/images/college.jpg";
import wormLogoFull from "../assets/images/worm_logo_full.svg";


const collegeImages = [
    "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1592280771190-3e2e4d571952?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1531050171651-a3a49696bb4d?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1590012314607-cda9d9b699ae?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1525921429624-479b6a26d84d?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1607237138186-b450704407cc?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1581362072978-14998d01fdaa?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1462536943532-57a629f6cc60?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1535982330050-f1c2fb970584?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1523580846011-d3a5bc25702b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1492538363530-973e00780287?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1507537362145-9f7e4e1a5f4a?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1558223608-b1310705a968?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1523240715639-963c6a28247b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1519452635265-7b1fbfd1e4e0?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1544148103-0773bf10d330?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1525921429624-479b6a26d84d?auto=format&fit=crop&w=800&q=80",
    "https://images.unsplash.com/photo-1472393365320-dc77242e6ff5?auto=format&fit=crop&w=800&q=80"
];



export default { profile, thumbnail, cards, cards2, path, logo, logoSmall, empty, logoNew, logoColor, toss, avatar, logo6, collegeImg, collegeImages, wormLogoFull };
